export default "__VITE_ASSET__D950sSoS__"